import React from "react";
const PSIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill={props.color ?? "#3A3A41"}
      d="M16 13.25H6.375c-.984 0-1.75-.766-1.75-1.75V5.375c0-.957.766-1.75 1.75-1.75h3.2c.464 0 .902.191 1.23.52l.738.738c.328.328.766.492 1.23.492H16c.957 0 1.75.793 1.75 1.75V11.5c0 .984-.793 1.75-1.75 1.75ZM3.312 6.031v6.125a2.392 2.392 0 0 0 2.407 2.406h8.75c.355 0 .656.301.656.657 0 .383-.3.656-.656.656h-8.75A3.688 3.688 0 0 1 2 12.156V6.031c0-.355.273-.656.656-.656.356 0 .656.3.656.656Z"
    />
  </svg>
);
export default PSIcon;
